import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { createAnimation, IonApp, IonRouterOutlet, loadingController } from '@ionic/vue';
import { onMounted, onUnmounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/store/auth';
import { initialise, resetConfig } from '@/adapter';
import emitter from '@/event-bus';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const authStore = useAuthStore();
const loader = ref<any>(null);
const maxAge = process.env.VUE_APP_CACHE_MAX_AGE ? parseInt(process.env.VUE_APP_CACHE_MAX_AGE) : 0;

const presentLoader = async (options: { message?: string; backdropDismiss?: boolean } = { message: '', backdropDismiss: true }) => {
  // When having a custom message remove already existing loader
  if (options.message && loader.value) dismissLoader();

  if (!loader.value) {
    loader.value = await loadingController.create({
      message: options.message ? t(options.message) : t('Click the backdrop to dismiss.'),
      translucent: true,
      backdropDismiss: options.backdropDismiss
    });
  }
  loader.value.present();
};

const dismissLoader = () => {
  if (loader.value) {
    loader.value.dismiss();
    loader.value = null as any;
  }
};

const playAnimation = () => {
  const aside = document.querySelector('aside') as Element;
  const main = document.querySelector('main') as Element;

  const revealAnimation = createAnimation()
    .addElement(aside)
    .duration(1500)
    .easing('ease')
    .keyframes([
      { offset: 0, flex: '0', opacity: '0' },
      { offset: 0.5, flex: '1', opacity: '0' },
      { offset: 1, flex: '1', opacity: '1' }
    ]);

  const gapAnimation = createAnimation()
    .addElement(main)
    .duration(500)
    .fromTo('gap', '0', 'var(--spacer-2xl)');

  createAnimation()
    .addAnimation([gapAnimation, revealAnimation])
    .play();
};

const unauthorized = async () => {
  // Mark the user as unauthorised, this will help in not making the logout api call in actions
  authStore.logout({ isUserUnauthorised: true });
  router.push('/login');
};

initialise({
  token: authStore.token.value,
  instanceUrl: authStore.oms,
  cacheMaxAge: maxAge,
  events: {
    unauthorised: unauthorized,
    responseError: () => {
      setTimeout(() => dismissLoader(), 100);
    },
    queueTask: (payload: any) => {
      emitter.emit('queueTask', payload);
    }
  }
});

onMounted(async () => {
  loader.value = await loadingController.create({
    message: t('Click the backdrop to dismiss.'),
    translucent: true,
    backdropDismiss: true
  });
  emitter.on('presentLoader', presentLoader);
  emitter.on('dismissLoader', dismissLoader);
});

onUnmounted(() => {
  emitter.off('presentLoader', presentLoader);
  emitter.off('dismissLoader', dismissLoader);
  resetConfig();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet))
    ]),
    _: 1
  }))
}
}

})